// Модель блока СКУД для формы конфигурации. JSON-имена snake_case — см. autopilot-config-skud-interfaces.md.
// null/undefined вместо списка трактуется как пустой список; null внутри списка не выкидывается (§5.3).

export function createSkudMain () {
  return {
    configuration: {
      sync_interval_min: 360,
      telemetry_interval_min: 60,
      screensaver_interval: 30,
      sound_enabled: true,
      volume: 70,
      reentry_block: 0,
      reexit_block: 0,
      guest_enabled: true,
      qr_enabled: true
    },
    pin_entrance_schedule: [],
    reboot_schedule: { hour: [], min: 0 }
  }
}

export function normalizeSkudMain (value) {
  const defaults = createSkudMain()
  if (!value || typeof value !== 'object') return defaults
  const configuration = { ...defaults.configuration }
  const sourceCfg = value.configuration && typeof value.configuration === 'object' ? value.configuration : {}
  for (const key of Object.keys(configuration)) {
    if (sourceCfg[key] !== undefined && sourceCfg[key] !== null) configuration[key] = sourceCfg[key]
  }
  const sourceReboot = value.reboot_schedule && typeof value.reboot_schedule === 'object' ? value.reboot_schedule : {}
  return {
    configuration,
    pin_entrance_schedule: Array.isArray(value.pin_entrance_schedule) ? deepCopy(value.pin_entrance_schedule) : [],
    reboot_schedule: {
      hour: Array.isArray(sourceReboot.hour) ? sourceReboot.hour.slice() : [],
      min: sourceReboot.min !== undefined && sourceReboot.min !== null ? sourceReboot.min : 0
    }
  }
}

function deepCopy (value) {
  return JSON.parse(JSON.stringify(value))
}
